import { render, staticRenderFns } from "./FullCutPicture.vue?vue&type=template&id=3e63aaf3&"
import script from "./FullCutPicture.vue?vue&type=script&lang=js&"
export * from "./FullCutPicture.vue?vue&type=script&lang=js&"
import style0 from "./FullCutPicture.vue?vue&type=style&index=0&id=3e63aaf3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports